// extracted by mini-css-extract-plugin
export default {"container":"SearchInput-module--container--FNo0E","search":"SearchInput-module--search--2TIot"};